module.exports = __webpack_public_path__ + "img/miejsce-parkingowe-zajete.184b9029.svg";